import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// Get all cars in work for monitoring page +
export const getAllCars = createAsyncThunk(
  "cars/getAllCars",
  async (params, thunkAPI) => {
    try {
      const { view, from_date, to_date, sort } = params;
      const response = await axiosNewApiInstance.get(`/api/v1/records/`, {
        params: {
          view,
          from_date,
          to_date,
          sort,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update record / car data +
export const updateRecordData = createAsyncThunk(
  "crm/updateRecordData",
  async (recordDataToUpdate, thunkAPI) => {
    try {
      const { recordId, ...recordDataToUpdateWithoutId } = recordDataToUpdate;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/records/${recordId}`,
        recordDataToUpdateWithoutId,
      );
      console.log(response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get current cars +
export const getCurrentCars = createAsyncThunk(
  "cars/getCurrentCars",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/current/cars`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": 2,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get cars for particular day - в новій АРІ не використовується поки що
export const getCarsByDate = createAsyncThunk(
  "cars/getCarsByDate",
  async (day, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vc/current/day/cars/?date=${day}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get load in % for each day in a particular month
export const getCalendarByMonth = createAsyncThunk(
  "cars/getCalendarByMonth",
  async (date, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    // const { month, year } = date;
    try {
      const response = await axiosInstance.get(
        `/vc/get_monthly_load?date=${date}`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get amount of cars per hour
export const getCarsForHour = createAsyncThunk(
  "cars/getCarsForHour",
  async (day, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.get(`/vc/get_busyness?date=${day}`, {
        headers: {
          // "X-Api-Key": "YA7NxysJ",
          "company-id": serviceId,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get load in % for one particular day
export const getPercentForHour = createAsyncThunk(
  "cars/getPercentForHour",
  async (day, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.get(`/vc/get_load_day?date=${day}`, {
        headers: {
          // "X-Api-Key": "YA7NxysJ",
          "company-id": serviceId,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get new cars in range of two particular dates +
export const getNewCarsRange = createAsyncThunk(
  "cars/getNewCarsRange",
  async (date, thunkAPI) => {
    const { dateBeginStr, dateEndStr } = date;
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/statistics/range?start_date=${dateBeginStr}&end_date=${dateEndStr}`,
        {
          headers: {
            "company-id": 2,
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get payments statistics for Stats Panel +
export const getPaymentStatistic = createAsyncThunk(
  "cars/getPaymentStatistic",
  async (date, thunkAPI) => {
    const { dateBeginStr, dateEndStr } = date;
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/payments/statistic?from_date=${dateBeginStr}&to_date=${dateEndStr}`,
        {
          headers: {
            "company-id": 2,
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Change car status
export const changeCarStatus = createAsyncThunk(
  "cars/changeCarStatus",
  async ({ carId, status }, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.post(`/vc/edit_status`, null, {
        params: {
          car_id: carId,
          status,
        },
        headers: {
          // "X-Api-Key": "YA7NxysJ",
          "company-id": serviceId,
        },
      });
      console.log("Status change response", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all cars in time period
export const getPeriodCars = createAsyncThunk(
  "cars/getPeriodCars",
  async (date, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    const { startDate, endDate } = date;
    try {
      const response = await axiosInstance.get(
        `/vc/get_all_car/?start_date=${startDate}&end_date=${endDate}`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get statistics for cars per month and day +
export const getStatistics = createAsyncThunk(
  "cars/getStatistics",
  async (timeSelection, thunkAPI) => {
    const { period, date } = timeSelection;
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/statistics?period=${period}&date=${date}`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": 2,
          },
        }
      );

      console.log("getStatistics", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
